<template>
  <div class='dbox'>
    <div class='header'>
      <h3>Choose State(s)</h3>
      <div>
        <b-link @click="tiggerShow"
                :class="{'un-activite': showmap}"
                data-test="geo-state-list">
          List</b-link>
        |
        <b-link @click="tiggerShow"
                :class="{'un-activite': !showmap}"
                data-test="geo-state-map">map</b-link>
      </div>
    </div>
    <m-state-map v-if="showmap" :geoType="geoType" :changeGeoType="geoType"></m-state-map>
    <m-state-list v-show="!showmap" :geoType="geoType" :changeGeoType="geoType"></m-state-list>
  </div>
</template>

<script>
  import MStateList from '@/Components/geo/MStateList'
  import MStateMap from '@/Components/geo/MStateMap'
  export default {
    components: {
      MStateList,
      MStateMap
    },
    props: {
      geoType: {
        type: Number
      }
    },
    data () {
      return {
        showmap: true
      }
    },
    methods: {
      tiggerShow () {
        this.showmap = !this.showmap
      }
    }
  }
</script>

<style scoped lang="scss">
  .un-activite {
    color: $color-text-grey;
  }
  .header {
      display: flex;
      justify-content: space-between;
    }

  .dbox {
    background-color: $color-background;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/geo/MGeoStateBox.vue